import { render } from "./MenuSocials.vue?vue&type=template&id=edc5567a&scoped=true"
import script from "./MenuSocials.vue?vue&type=script&lang=js"
export * from "./MenuSocials.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=edc5567a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc5567a"]])

export default __exports__